import { gql } from '@apollo/client';

const GET_FILTERS = gql`
  query GetFilters($view: String!) {
    filters @client(always: true) {
      modelSpecifications {
        Authors
        CreationDate
        ModelCategories
        search
        SharedTo
      }
      projects {
        Authors
        CreationDate
      }
    }
  }
`;

export default GET_FILTERS;
